import { DateHelper } from "@/utility/dateHelper.js";

import { date } from "@/components/mixins/date";

export const STACKED_PERCENTAGE_COLORS = {
  GREEN: "#26DE81", // green
  GREEN_BARRED: {
    pattern: {
      path: {
        d: "M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11"
      },
      width: 10,
      height: 10,
      opacity: 1,
      color: "#26DE81"
    }
  }, //cyan
  BLUE: "#026CFF", // blue
  YELLOW: "#FED330", // yellow
  RED: "#FC5C65", // red
  VIOLET: "#BA5CFC", // violet
  GRAY: "#E7E7E7" // gray
};

export const ANALYTICS_MODEL = {
  MachineId: "",
  Availability: 0,
  Performance: 0,
  Quality: 0,
  OEE: 0,
  Pieces: {
    Good: 0,
    Defective: 0,
    Total: 0,
    Velocity: 0,
    Goal: 0
  },
  UsageTimes: {
    MainUsage: 0,
    MinorStoppage: 0,
    SecondaryUsage: 0,
    Idle: 0,
    Maintenance: 0,
    TechnicalFault: 0,
    EmptyBusy: 0
  },
  WasteTimes: {
    Idle: 0,
    ShortageOfMaterial: 0,
    QualityCheck: 0,
    Setup: 0,
    DefectiveMaterial: 0,
    MissingInstructions: 0,
    Break: 0,
    MachineProgramEditing: 0,
    Cleaning: 0,
    Others: 0,
    MachineFault: 0,
    Maintenance: 0
  },
  MainUsageLevel: 0,
  RunTime: 0,
  AvailableTime: 0,
  UtilizationTime: 0,
  UtilizationAvailability: 0,
  TechnicalAvailability: 0
};

const getColor = time =>
  ({
    MAINUSAGE: STACKED_PERCENTAGE_COLORS.GREEN,
    MINORSTOPPAGE: STACKED_PERCENTAGE_COLORS.GREEN_BARRED,
    SECONDARYUSAGE: STACKED_PERCENTAGE_COLORS.BLUE,
    IDLE: STACKED_PERCENTAGE_COLORS.YELLOW,
    TECHNICALFAULT: STACKED_PERCENTAGE_COLORS.RED,
    MAINTENANCE: STACKED_PERCENTAGE_COLORS.VIOLET,
    EMPTYBUSY: STACKED_PERCENTAGE_COLORS.GRAY
  }[time.toUpperCase()] || "#FFFFFF");

export const roundValue = (v, round = 2) => {
  const value = v !== 0 && typeof v === "number" ? v.toFixed(round) : 0;
  return Number(value);
};

export const mapToChartSerie = (objTimes, translations) => {
  const ORDERED_SERIES = [
    "MainUsage",
    "MinorStoppage",
    "SecondaryUsage",
    "Idle",
    "TechnicalFault",
    "Maintenance",
    "EmptyBusy"
  ];
  let series = [];

  const objTimesCopy = Object.keys(objTimes).reduce((acc, key) => {
    acc[key] = objTimes[key] ? roundValue(objTimes[key]) : 0;
    return acc;
  }, {});

  const sum = Object.keys(objTimesCopy).reduce((s, k) => (s += objTimesCopy[k]), 0);

  // N.B. Reverse series item for correct sort view  chart
  series = ORDERED_SERIES.map(time => {
    const seconds = objTimesCopy[time] ? objTimesCopy[time] : 0;

    // Set seconds into H m s seconds
    const formatted_hms = seconds > 0 ? DateHelper.getFancyTimeFormat(seconds) : "0h";

    // Set percentage
    const p = objTimesCopy[time] ? (objTimesCopy[time] / sum) * 100 : 0;
    const percentage = Math.round(p * 10) / 10;

    return {
      data: [seconds],
      color: getColor(time),
      name: `${translations(
        "analytics.usageTimes." + time.toUpperCase()
      )} ${percentage}% (${formatted_hms})`
    };
  }).reverse();

  return series;
};

export const DEFAULT_ANALYTICS_FILTER = {
  from: date.methods
    .objDatePlusTime({ days: -7 }, date.methods.objDateTodayStartOf("day"))
    .toISOString(),
  to: date.methods
    .objDatePlusTime({ days: -1 }, date.methods.objDateTodayEndOf("day"))
    .toISOString(),
  kpiCalcMethod: "CLASSIC_MODEL"
};
